import { render, staticRenderFns } from "./PlayerInfo.vue?vue&type=template&id=7da019be&"
import script from "./PlayerInfo.vue?vue&type=script&lang=ts&"
export * from "./PlayerInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports